import { render, staticRenderFns } from "./adproduct.vue?vue&type=template&id=fafa1592&scoped=true"
import script from "./adproduct.vue?vue&type=script&lang=js"
export * from "./adproduct.vue?vue&type=script&lang=js"
import style0 from "./adproduct.vue?vue&type=style&index=0&id=fafa1592&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fafa1592",
  null
  
)

export default component.exports